<template>
  <div class="infinite-scrolling">
    <slot></slot>

    <div v-if="showEnd" class="d-flex justify-content-center placeholder mt-4" :class="{notDeepSearching: !deepSearching}" ref="end">
      <div v-if="loading" class="spinner-border text-primary" role="status" key="loading">
        <span class="sr-only">Bezig met laden...</span>
      </div>
      <span v-else-if="ended" key="end-of-list">
        Geen items meer gevonden
      </span>
      <button v-else-if="!deepSearching || alwaysShowShowMoreButton"
        type="button"
        class="btn btn-light"
        style="height: 26px"
        
        key="keep-searching"
        @click="trigger(false)"
      >
        Blijf zoeken
      </button>
      <span v-else style="opacity: 0">
        a
      </span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    searchMore: {
      type: Function,
      required: true,
    },
    showEnd: {
      type: Boolean,
      default: true,
      required: false,
    },
    alwaysShowShowMoreButton: Boolean,
  },
  data() {
    return {
      loading: false,
      deepSearching: false,
      ended: false,
      offset: 1,
    }
  },
  mounted() {
    this.showEnd && this.initiateObserver()
  },
  beforeDestroy() {
    this.destroyObserver()
  },
  methods: {
    reset() {
      this.deepSearching = false
      this.offset = 1
      this.ended = false
      this.loading = false
    },
    initiateObserver() {
      this.observer && this.destroyObserver()
      
      this.observer = new IntersectionObserver(evt => {
        if (this.alwaysShowShowMoreButton) return;
        
        if (evt[0].intersectionRatio === 1) {
          this.trigger(true)
        }
      }, {
        threshold: 1,
      })
      
      this.observer.observe(this.$refs.end)
    },
    destroyObserver() {
      this.observer && this.observer.disconnect()
      this.observer = null
    },
    
    async trigger(observed) {
      if (observed && !this.deepSearching) return;
      
      this.deepSearching = true
      this.offset++
      
      this.loading = true
      this.ended = await this.searchMore(this.offset)
      this.loading = false
    },
  },
  watch: {
    showEnd(show) {
      show ? this.$nextTick(this.initiateObserver) : this.destroyObserver()
    },
  },
}

</script>

<style scoped>

.infinite-scrolling {
  width: 100%;
}

.placeholder {
  position: relative;
  margin-bottom: 8px;
}

.btn {
  position: absolute;
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  z-index: 20;
  pointer-events: all;
}

.notDeepSearching {
  position: relative;
  z-index: 20;
  padding-bottom: 18px !important;
}

</style>
